import { render, staticRenderFns } from "./PersistBlockchainVersionView.vue?vue&type=template&id=7a0a26b8"
import script from "./PersistBlockchainVersionView.vue?vue&type=script&lang=ts"
export * from "./PersistBlockchainVersionView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports